import * as React from 'react';
import { EventIndexView } from '../../../types/events';
import { observer } from 'mobx-react';
import Slider from 'react-slick';
import { EventCard } from '../../molecules/events/EventCard';
import './mobileEventListPane.scss';

type Props = {
    events: EventIndexView[];
    onItemClick: (event) => any;
};

@observer
export class SpEventListPane extends React.Component<Props> {
    render() {
        const { events, onItemClick } = this.props;
        return (
            <div className="mobile-event-list-pane">
                {events.map((event) => (
                    <div key={event.id}>
                        <EventCard event={event} onClick={() => onItemClick(event)} />
                    </div>
                ))}
            </div>
        );
    }
}
